import { Button, Center, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ErrorIcon from '@/assets/icons/ic-error.svg';

import { getMessage } from '@/components/ui/shared/conversation/Chat/Chat.utils';

export interface IChatError {
  error: Error;
  clearError: () => void;
}

export const ChatError: FC<IChatError> = ({ error, clearError }) => {
  const { t } = useTranslation();
  const errorMessage = getMessage(error);

  return (
    <Center h="full">
      <VStack>
        <ErrorIcon width="60px" height="60px" color="#CACCCC" />
        <Text w={{ base: '100%', md: '80%' }} textAlign="center">
          {t('conversation.errorLoadingChat')}
        </Text>

        <Text w={{ base: '100%', md: '80%' }} fontStyle="italic" textAlign="center">
          {errorMessage}
        </Text>

        <Button height="40px" onClick={clearError}>
          {t('conversation.errorRetry')}
        </Button>
      </VStack>
    </Center>
  );
};
